import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { useAuthContext } from '../hooks/useAuthContext';
//importing components
// import ReportsOverview from '../components/ReportsOverview';
import RequestsOverview from '../components/RequestsOverview';
import PurchaseOrdersOverview from '../components/PurchaseOrdersOverview';
import SalesOrdersOverview from '../components/SalesOrderOverview';
import InventoryOverview from '../components/InventoryOverview';
import KpiCard from '../components/KpiCard';

const Home = () => {
    const {user} = useAuthContext();
    const [stripeSessionRes, setStripeSessionRes] = useState(' ');
    const [monthlySales, setMonthlySales] = useState(0);
    const [monthlySalesCount, setMonthlySalesCount] = useState(0);
    const [monthlyPurchases, setMonthlyPurchases] = useState(0);
    const month = new Date().getMonth() + 1;
    const year = new Date().getFullYear();

    useEffect(() => {
        const getStripeSession = async () => {
            const userId = user.userId;
            const response = await axios.post(process.env.REACT_APP_SERVER_URL + '/api/stripe/stripe-session', {userId});
            setStripeSessionRes(response.data);
        }

        const getMonthlySales = async () => {
            const response = await axios.get(
                // eslint-disable-next-line
                process.env.REACT_APP_SERVER_URL + '/api/reports/monthly-sales-totals' + `?month=${month}&year=${year}`, 
                {headers: {'Authorization': `Bearer ${user.token}`}}
            );
            setMonthlySales(response.data.saleTotal);
            setMonthlySalesCount(response.data.watchesSold);
        }

        const getMonthlyPurchases = async () => {
            const response = await axios.get(
                // eslint-disable-next-line
                process.env.REACT_APP_SERVER_URL + '/api/reports/monthly-purchase-totals' + `?month=${month}&year=${year}`,
                {headers: {'Authorization': `Bearer ${user.token}`}}
            );
            setMonthlyPurchases(response.data);
        }

        //only get stripe session if user exists
        if (user) {
            getStripeSession();
            getMonthlySales();
            getMonthlyPurchases();
        }
    }, [user, month, year]);

    const monthlyProfit = monthlySales - monthlyPurchases;

    return(
        <div className="home">
            {/* <h1 className="page-title">Home</h1> */}
            <div className="kpi-container">
                <KpiCard title='Monthly Profit' value={`$${monthlyProfit}`} />
                <KpiCard title='Watches Sold' value={`${monthlySalesCount}`} />
            </div>
            <div className="overviews-container">
                <RequestsOverview />
                <InventoryOverview />
                <PurchaseOrdersOverview />
                <SalesOrdersOverview />
            </div>
            {stripeSessionRes === 'fail' ? <p>Did not retrieve Stripe session.</p> : null}
        </div>
    )
}

export default Home;